import {APIClient} from "../../base";
import {PaginationInterface} from "../../../../interfaces/PaginationInterface";
import {IntegrateInterface} from "../../../../interfaces/private/IntegrateInterface";

const IntegrateV1Api = {
    list: async (pagination: PaginationInterface) => await APIClient.get('/v1/integrate', pagination),
    detail: async (id: number) => await APIClient.get('/v1/integrate/' + id, {}),
    create: async (model: IntegrateInterface) => await APIClient.create('/v1/integrate', model),
    update: async (id: number, model: IntegrateInterface) => await APIClient.update('/v1/integrate/' + id, model),
    delete: async (id: number|string|any) => await APIClient.delete('/v1/integrate/' + id, {}),
    syncInvoice: async (params?: any) => await APIClient.post('/v1/integrate/invoice', params),
    retryInvoice: async (reference: string) => await APIClient.post(`/v1/integrate/invoice/${encodeURIComponent(reference)}/retry`, {}),
    syncPayment: async (params?: any) => await APIClient.post('/v1/integrate/payment', params),
    syncPayout: async (params?: any) => await APIClient.post('/v1/integrate/payout', params),
    syncSubscription: async () => await APIClient.post('/v1/integrate/subscription', {}),
};

export default IntegrateV1Api;
